// [ICON_LIST_START]
const iconsList = {
    chat: "chat",
    user: "user",
    back: "back",
    profile: "profile",
    profilePurple: "profilePurple",
    close: "close",
    eye: "eye",
    x: 'x',
    like: "like",
    down: "down",
    aiMonth: "aiMonth",
    calendar: "calendar",
    calendarWithoutNumbers: "calendarWithoutNumbers",
    myLearning: "myLearning",
    arrows: "arrows",
    discovery: "discovery",
    plusLearning: "plusLearning",
    professionalDevelopment: "professionalDevelopment",
    messages: "messages",
    usefulTools: "usefulTools",
    bgt: "bgt",
    bgtTasks: "bgtTasks",
    bgtLearningSpaces: "bgtLearningSpaces",
    bagrut: "bagrut",
    edit: "edit",
    editElement: "editElement",
    editElement: "editElement",
    radar: "radar",
    home: "home",
    realisticIsrael: "realisticIsrael",
    task: "task",
    tasks: "tasks",
    accessibility: "accessibility",
    support: "support",
    closeCircle: "closeCircle",
    shortcuts: "shortcuts",
    finalProjects: "finalProjects",
    timerIcon: "timerIcon",
    timer: "timer",
    focusIcon: "focusIcon",
    approvedIcon: "approvedIcon",
    presentationIcon: "presentationIcon",
    archiveBookIcon: "archiveBookIcon",
    finalProgectWidgetIcon: "finalProgectWidgetIcon",
    shortcuts: "shortcuts",
    heritagePaths: "heritagePaths",
    send: "send",
    delete: "delete",
    download: "download",
    arrowTriangular: "arrowTriangular",
    directInbox: "directInbox",
    addCircle:"addCircle",
    addCircleButton:"addCircleButton",
    addImg: "addImg",
    championship: "championship",
    googleMeet: "googleMeet",
    copy: "copy",
    tehuda: "tehuda",
    heroism: "heroism",
    clearSearch: "clearSearch",
    filter: "filter",
    confirm: "confirm",
    managerDashboard: "managerDashboard",
    checkmark: "checkmark",
    caretDown: "caretDown",
    closeCircleFilled: "closeCircleFilled",
    galleryAdd: "galleryAdd",
    infoCircle: "infoCircle",
    lock: "lock",
    search: "search",
    discoverySearch: "discoverySearch",
    confirm: "confirm",
    scheduleZoomOut: "scheduleZoomOut",
    scheduleZoomIn: "scheduleZoomIn",
    scheduleRotate: "scheduleRotate",
    scheduleEditImage: "scheduleEditImage",
    scheduleTabPersonal: "scheduleTabPersonal",
    scheduleTabClass: "scheduleTabClass",
    scheduleFileInfo: "scheduleFileInfo",
    openImg: "openImg",
    plusCircle: "plusCircle",
    editCircle: "editCircle",
    openInNewTab: "openInNewTab",
    star: "star",
    starOutline: "starOutline",
    checkSquare: "checkSquare",
    alertTriangle: "alertTriangle",
    confirm: "confirm",
    managerDashboard: "managerDashboard",
    checkmark: "checkmark",
    caretDown: "caretDown",
    closeCircleFilled: "closeCircleFilled",
    galleryAdd: "galleryAdd",
    infoCircle: "infoCircle",
    lock: "lock",
    search: "search",
    google: "google",
    microsoft: "microsoft",
    faq: "faq",
    bot: "bot",
    tabScrollChevron: "tabScrollChevron",
    financialEducation: "financialEducation",
}
// [ICON_LIST_END]
export default iconsList
